import { cva, type VariantProps } from 'class-variance-authority';
import { Loader2Icon } from 'lucide-react';
import type { ComponentProps } from 'react';
import { uiText } from '../i18n.js';
import { cn } from '../lib/utils.js';

export const spinnerVariants = cva('text-muted-foreground animate-spin', {
  variants: {
    size: {
      sm: 'size-3',
      default: 'size-4',
      lg: 'size-6',
      xl: 'size-8',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export interface SpinnerProps extends ComponentProps<'svg'>, VariantProps<typeof spinnerVariants> {
  /** Override do aria-label. Quando omitido, usa `uiText('common.loading')`
      que respeita a locale ativa do `I18nProvider`. */
  readonly label?: string;
}

export function Spinner({ size, label, className, ...props }: Readonly<SpinnerProps>) {
  return (
    <Loader2Icon
      data-slot="spinner"
      role="status"
      aria-label={label ?? uiText('common.loading')}
      className={cn(spinnerVariants({ size }), className)}
      {...props}
    />
  );
}
